export const MIDIA_TYPES = {
  WEBHOOK: 'webhook',
  EXPORT_WPP: 'export_wpp',
  MULTIMEDIA: 'multimedia',
};

export const STORAGE_ORIGINS = [
  { value: 'gcs_intelia', labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.OPTIONS.GCS_INTELIA' },
  { value: 'gcs_external', labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.OPTIONS.GCS_EXTERNAL' },
  { value: 'amazon_s3', labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.OPTIONS.AMAZON_S3' },
  { value: 'sftp', labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.OPTIONS.SFTP' },
];

export const ORIGIN_CREDENTIAL_CONFIGS = {
  gcs_intelia: null,

  gcs_external: {
    type: 'file',
    titleKey: 'MULTIMEDIA_SECTION_CREDENTIALS_TITLE',
    subtitleKey: 'MULTIMEDIA_SECTION_CREDENTIALS_SUBHEADER',
    loadFromSecret: false,
    usesBucket: true,
    initialState: inbox => ({
      credentials: undefined,
      credentials_filename: inbox?.custom_config?.credentials_filename || '',
    }),
  },

  amazon_s3: {
    type: 'fields',
    titleKey: 'MULTIMEDIA_SECTION_S3_CREDENTIALS_TITLE',
    subtitleKey: 'MULTIMEDIA_SECTION_S3_CREDENTIALS_SUBHEADER',
    loadFromSecret: true,
    usesBucket: true,
    fields: [
      {
        key: 'access_key_id',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.ACCESS_KEY',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.ACCESS_KEY_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.ACCESS_KEY_ERROR',
        inputType: 'text',
      },
      {
        key: 'secret_access_key',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.SECRET_ACCESS_KEY',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.SECRET_ACCESS_KEY_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.SECRET_ACCESS_KEY_ERROR',
        inputType: 'password',
      },
      {
        key: 'region',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.REGION',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.REGION_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.S3_CREDENTIALS.REGION_ERROR',
        inputType: 'text',
      },
    ],
    initialState: () => ({ access_key_id: '', secret_access_key: '', region: '' }),
  },

  sftp: {
    type: 'fields',
    titleKey: 'MULTIMEDIA_SECTION_SFTP_CREDENTIALS_TITLE',
    subtitleKey: 'MULTIMEDIA_SECTION_SFTP_CREDENTIALS_SUBHEADER',
    loadFromSecret: true,
    usesBucket: false,
    fields: [
      {
        key: 'host',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.HOST',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.HOST_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.HOST_ERROR',
        inputType: 'text',
      },
      {
        key: 'port',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.PORT',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.PORT_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.PORT_ERROR',
        inputType: 'text',
        isInteger: true,
      },
      {
        key: 'username',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.USERNAME',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.USERNAME_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.USERNAME_ERROR',
        inputType: 'text',
      },
      {
        key: 'password',
        labelKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.PASSWORD',
        placeholderKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.PASSWORD_PLACEHOLDER',
        errorKey: 'INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.SFTP_CREDENTIALS.PASSWORD_ERROR',
        inputType: 'password',
      },
    ],
    initialState: () => ({ host: '', port: '22', username: '', password: '' }),
  },
};

export default {
  computed: {
    midiaType() {
      return this.inbox.midia;
    },
    whatsAppAPIProvider() {
      return this.inbox.provider || '';
    },
    isMidiaWebhook() {
      return this.midiaType === MIDIA_TYPES.WEBHOOK;
    },
    isMidiaExport() {
      return this.midiaType === MIDIA_TYPES.EXPORT_WPP;
    },
    isMidiaMultimedia() {
      return this.midiaType === MIDIA_TYPES.MULTIMEDIA;
    },
  },
};
